import { render, staticRenderFns } from "./DeptBaseInfo.vue?vue&type=template&id=86c4603c&scoped=true&"
import script from "./DeptBaseInfo.vue?vue&type=script&lang=js&"
export * from "./DeptBaseInfo.vue?vue&type=script&lang=js&"
import style0 from "./DeptBaseInfo.vue?vue&type=style&index=0&id=86c4603c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86c4603c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('86c4603c')) {
      api.createRecord('86c4603c', component.options)
    } else {
      api.reload('86c4603c', component.options)
    }
    module.hot.accept("./DeptBaseInfo.vue?vue&type=template&id=86c4603c&scoped=true&", function () {
      api.rerender('86c4603c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/modules/DeptBaseInfo.vue"
export default component.exports